import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../ContactModal.css';
import { DialogActions, Typography, Link, Divider } from '@mui/joy';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Check from '@mui/icons-material/Check';
import { agreeEmail, disagreeEmail } from '../emailTempates';
import avatar from '../../../Male_Avatar.jpg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const ContactPage = ({ representative, setOpen, bill, stance, address }) => {
    const [emailText, setEmailText] = useState('');
    const [italic, setItalic] = React.useState(false);
    const [fontWeight, setFontWeight] = React.useState('normal');
    const [anchorEl, setAnchorEl] = React.useState(null);
    
    const handleInputChange = (event) => {
        setEmailText(event.target.value);
    };
  
    useEffect(() => {
        const template = stance === 'oppose' ? 
            disagreeEmail(representative, bill, address) : 
            agreeEmail(representative, bill, address)
        setEmailText(template)
    }, [representative, bill, stance, address])

    const goToRepWebsite = () => {
        window.open(representative.officialWebsiteUrl,'_blank')
    };

    return (
        <>
        <Typography level="h3">Here’s Your Representative and Your Message</Typography>
        <Typography level="body-md">
            We’ve matched you with your representative. 
            Below is a draft email based on your input. 
            Feel free to review and make any changes before sending.
        </Typography>
        <Box sx={{padding: 2}}>
            <div className="author">
                <img src={representative.imageUrl || avatar} alt={representative.fullName} />
                <div className='text'>
                    <Typography level="title-md">{representative.fullName}</Typography>
                    <Link to={representative.officialWebsiteUrl}><Typography level="body-sm">{representative.party} - {representative.state}</Typography></Link>
                </div>
            </div>
        </Box>
        <Divider />
        <Box sx={{padding: 2, overflowY: 'scroll'}}>
        <FormControl sx={{maxHeight: '300px'}}>
            <FormLabel>Your template</FormLabel>
            <Textarea
                placeholder="Type something here…"
                value={emailText}
                onChange={handleInputChange}
                minRows={3}
                endDecorator={
                <Box
                    sx={{
                    display: 'flex',
                    gap: 'var(--Textarea-paddingBlock)',
                    pt: 'var(--Textarea-paddingBlock)',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    flex: 'auto',
                    }}
                >
                    <IconButton
                        variant="plain"
                        color="neutral"
                        onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                        <FormatBold />
                        <KeyboardArrowDown fontSize="md" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        size="sm"
                        placement="bottom-start"
                        sx={{ '--ListItemDecorator-size': '24px' }}
                    >
                        {['200', 'normal', 'bold'].map((weight) => (
                            <MenuItem
                            key={weight}
                            selected={fontWeight === weight}
                            onClick={() => {
                                setFontWeight(weight);
                                setAnchorEl(null);
                            }}
                            sx={{ fontWeight: weight }}
                            >
                            <ListItemDecorator>
                                {fontWeight === weight && <Check fontSize="sm" />}
                            </ListItemDecorator>
                            {weight === '200' ? 'lighter' : weight}
                            </MenuItem>
                        ))}
                    </Menu>
                    <IconButton
                        variant={italic ? 'soft' : 'plain'}
                        color={italic ? 'primary' : 'neutral'}
                        aria-pressed={italic}
                        onClick={() => setItalic((bool) => !bool)}
                    >
                        <FormatItalic />
                    </IconButton>
                    <IconButton
                        variant="plain"
                        color="neutral"
                        sx={{ ml: 'auto' }}
                        onClick={() => navigator.clipboard.writeText(emailText)}
                    >
                        <ContentCopyIcon fontSize="md" />
                    </IconButton>
                </Box>
                }
                sx={[
                {
                    minWidth: 300,
                    fontWeight,
                },
                italic ? { fontStyle: 'italic' } : { fontStyle: 'initial' },
                ]}
            />
        </FormControl>
        </Box>
        <DialogActions>
            <Button variant="solid" color="primary" onClick={goToRepWebsite}>
                Contact my representative
            </Button>
            <Button variant="plain" color="neutral" onClick={() => setOpen(false)}>
                Close
            </Button>
        </DialogActions>
        </>
    );
};

// Prop types for our Component
ContactPage.propTypes = {
    setOpen: PropTypes.func.isRequired,
    stance: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    representative: PropTypes.object.isRequired,
    bill: PropTypes.object.isRequired,
}
 
// Default Props for our Component
ContactPage.defaultProps = {
}

export default ContactPage;